import "./styles/fonts";
import "./styles/tokens.css";
import "./styles/global.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { ToastProvider } from "./components/Toast";
import { createRouter } from "./routes/router";
import { applyTheme, readStoredTheme, resolveTheme, systemPrefersDark } from "./theme/theme";
import { ThemeProvider } from "./theme/ThemeProvider";

// Set the theme before the first render to avoid a light flash in dark mode.
applyTheme(resolveTheme(readStoredTheme(), systemPrefersDark()));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

const router = createRouter();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
